import axios from 'axios';
import { AUTH_REQUEST, LOGIN_SUCCESS, REGISTER_SUCCESS, AUTH_FAILURE, LOGOUT, USER_UPDATE } from '../actionTypes';
import { toast } from 'react-toastify';
import { DEV_API } from '../../const';

export const getUserAct = (userData) => async (dispatch) => {
  // dispatch({ type: AUTH_REQUEST });
  try {
    const response = await axios.get(`${DEV_API}/api/users`, {
      params: userData
    });

    if(response.data.success){
      dispatch({ type: USER_UPDATE, payload: { user: response.data.result } });
    } else {
      // toast(response.data.message);
      console.log(response.data.message);
    }
  } catch (error) {
    // dispatch({ type: AUTH_FAILURE, payload: error.message });
    // toast(error.message)
    console.log(error.message)
    toast('Server Error')
  }
};

export const updateUserAct = (udpateData) => async (dispatch) => {
  // dispatch({ type: AUTH_REQUEST });
  try {
    const response = await axios.put(`${DEV_API}/api/users`, udpateData);

    if(response.data.success){
      dispatch({ type: USER_UPDATE, payload: { user: response.data.result } });
    } else {
      toast(response.data.message);
    }
  } catch (error) {
    // dispatch({ type: AUTH_FAILURE, payload: error.message });
    toast(error.message)
  }
};